import {Component, Input, OnInit} from '@angular/core';
import {notify, Vehicle} from 'shared';
import {TractorService} from '../../stores/tractor.service';
import {catchError} from 'rxjs/operators';
import {throwError} from 'rxjs';

@Component({
  selector: 'app-vehicles-tracker-state-icons-selector',
  templateUrl: './vehicles-tracker-state-icons-selector.component.html',
  styleUrls: ['./vehicles-tracker-state-icons-selector.component.scss']
})
export class VehiclesTrackerStateIconsSelectorComponent implements OnInit {

  @Input()
  item: Vehicle;
  visible: boolean;
  loadIndicatorVisible: boolean;

  constructor(private tractorService: TractorService) {
    this.save = this.save.bind(this);
    this.close = this.close.bind(this);
  }

  ngOnInit(): void {
  }

  changeIcon(vehicle: Vehicle) {
    this.item = vehicle;
    this.visible = true;
  }

  save() {
    this.loadIndicatorVisible = true;
    this.tractorService.saveSettings(this.item).pipe(catchError((error) => {
      this.loadIndicatorVisible = false;
      return throwError(error);
    })).subscribe(_ => {
      notify('Icon mis à jour avec succès');
      this.loadIndicatorVisible = false;
      this.visible = false;
    });
  }

  close() {
    this.visible = false;
  }

  closed(e: any) {
  }

}
